export type HiddenInputProps = {
  name: string;
  value: string | number | number[] | null;
};

export const HiddenInput = ({ name, value }: HiddenInputProps) => {
  return <input type="hidden" name={name} defaultValue={String(value)} />;
};

export default HiddenInput;
